// ----------------- VARIABLES -----------------
import { OrientationEstimator } from "./OrientationEstimation";
import { AngleRFEstimator } from "./AngleRFEstimation";

let orientationEstimator = new OrientationEstimator();
let angleRFEstimator = new AngleRFEstimator();

const getMode = (arr) => {
  if (!arr.length) return null;
  const freq = {};
  arr.forEach((v) => (freq[v] = (freq[v] || 0) + 1));
  return Object.keys(freq).reduce((a, b) => (freq[a] > freq[b] ? a : b));
};

// Angle variables
let angleSlidingWindow = [];
let angleWindowSize = 5;
let angleCollectionList = [];
let angleCollectionListLengthThreshold = 5;
let aggregatedAngle = -1;

// Orientation variables
let orientationSlidingWindow = [];
let orientationWindowSize = 5;
let orientationCollectionList = [];
let orientationCollectionListLengthThreshold = 5;
let aggregatedOrientation = -1;

// ----------------- EXPORTED FUNCTION -----------------
export const getAngleFromDetections = (detections) => {
  // Step 1: Get raw angle + orientation
  const angleOfFrame = angleRFEstimator.getAngleOfFrame(detections);
  const orientation = orientationEstimator.getCarOrientation(detections);

  // Step 2: Push into sliding windows
  angleSlidingWindow.push(angleOfFrame);
  orientationSlidingWindow.push(orientation);

  // Step 3: Aggregate sliding window → push into collection
  if (angleSlidingWindow.length >= angleWindowSize) {
    angleCollectionList.push(getMode(angleSlidingWindow));
    angleSlidingWindow = [];
  }
  if (orientationSlidingWindow.length >= orientationWindowSize) {
    orientationCollectionList.push(getMode(orientationSlidingWindow));
    orientationSlidingWindow = [];
  }

  // Step 4: Final aggregation from collection list
  if (angleCollectionList.length >= angleCollectionListLengthThreshold) {
    aggregatedAngle = getMode(angleCollectionList);
    angleCollectionList = [];
  }
  if (
    orientationCollectionList.length >= orientationCollectionListLengthThreshold
  ) {
    aggregatedOrientation = getMode(orientationCollectionList);
    orientationCollectionList = [];
  }

  // Step 5: Validation checks
  if (aggregatedAngle === -1 || aggregatedOrientation === -1) {
    return -1;
  }

  if (aggregatedOrientation === "Unclear") {
    if (aggregatedAngle >= 20 && aggregatedAngle <= 160) {
      aggregatedAngle = -1;
      aggregatedOrientation = -1;
      return -1;
    }
    return aggregatedAngle;
  }

  // Step 6: Adjust based on orientation
  if (aggregatedOrientation === "Left") {
    return 360 - aggregatedAngle;
  } else if (aggregatedOrientation === "Right") {
    return aggregatedAngle;
  }

  // Default return aggregatedAngle
  return aggregatedAngle;
};
